export default __webpack_public_path__ + "static/media/sample_2.2807ab1c.png";